export default __webpack_public_path__ + "static/brickscontainer-00461a589dc23d42c10ec35d16643b09.jpg";